import 'pikaday/plugins/pikaday.jquery';

import Pikaday from 'pikaday';

window.Pikaday = Pikaday;
